module.exports = __webpack_public_path__ + "img/9.ceaeed09.png";